export default {
  methods: {
    buscarNacionalidad (pais) {
      const paises = this.getPaises();
      for (let i in paises) {
        if (paises[i].pais === pais) {
          return paises[i].nacionalidad;
        }
      }
      return pais;
    },
    getPaises () {
      return [
        { 'nacionalidad': 'AFGANA', 'pais': 'AFGANISTÁN' },
        { 'nacionalidad': 'ALBANESA', 'pais': 'ALBANIA' },
        { 'nacionalidad': 'ALEMANA', 'pais': 'ALEMANIA' },
        { 'nacionalidad': 'ALTO VOLTEÑA', 'pais': 'ALTO VOLTA' },
        { 'nacionalidad': 'ANDORRANA', 'pais': 'ANDORRA' },
        { 'nacionalidad': 'ANGOLEÑA', 'pais': 'ANGOLA' },
        { 'nacionalidad': 'ARGELINA', 'pais': 'ARGELIA' },
        { 'nacionalidad': 'ARGENTINA', 'pais': 'ARGENTINA' },
        { 'nacionalidad': 'AUSTRALIANA', 'pais': 'AUSTRALIA' },
        { 'nacionalidad': 'AUSTRIACA', 'pais': 'AUSTRIA' },
        { 'nacionalidad': 'BAHAMESA', 'pais': 'BAHAMAS' },
        { 'nacionalidad': 'BAHREINA', 'pais': 'BAHREIN' },
        { 'nacionalidad': 'BANGLADESHA', 'pais': 'BANGLADESH' },
        { 'nacionalidad': 'BARBADESA', 'pais': 'BARBADOS' },
        { 'nacionalidad': 'BELGA', 'pais': 'BELGICA' },
        { 'nacionalidad': 'BELICEÑA', 'pais': 'BELICE' },
        { 'nacionalidad': 'BERMUDESA', 'pais': 'BERMUDAS' },
        { 'nacionalidad': 'BIRMANA', 'pais': 'BIRMANIA' },
        { 'nacionalidad': 'BOLIVIANA', 'pais': 'BOLIVIA' },
        { 'nacionalidad': 'BOTSWANESA', 'pais': 'BOTSWANA' },
        { 'nacionalidad': 'BRASILEÑA', 'pais': 'BRASIL' },
        { 'nacionalidad': 'BULGARA', 'pais': 'BULGARIA' },
        { 'nacionalidad': 'BURUNDESA', 'pais': 'BURUNDI' },
        { 'nacionalidad': 'BUTANA', 'pais': 'BUTAN' },
        { 'nacionalidad': 'CAMBOYANA', 'pais': 'KHEMER REP DE CAMBOYA ' },
        { 'nacionalidad': 'CAMERUNESA', 'pais': 'CAMERUN' },
        { 'nacionalidad': 'CANADIENSE', 'pais': 'CANADA' },
        { 'nacionalidad': 'CENTROAFRICANA', 'pais': 'REP CENTROAFRICANA' },
        { 'nacionalidad': 'CHADEÑA', 'pais': 'CHAD' },
        { 'nacionalidad': 'CHECOSLOVACA', 'pais': 'REP. CHECA' },
        { 'nacionalidad': 'CHILENA', 'pais': 'CHILE' },
        { 'nacionalidad': 'CHINA', 'pais': 'CHINA' },
        { 'nacionalidad': 'CHINA', 'pais': 'TAIWAN' },
        { 'nacionalidad': 'CHIPRIOTA', 'pais': 'CHIPRE' },
        { 'nacionalidad': 'COLOMBIANA', 'pais': 'COLOMBIA' },
        { 'nacionalidad': 'CONGOLEÑA', 'pais': 'CONGO' },
        { 'nacionalidad': 'COSTARRICENSE', 'pais': 'COSTA RICA' },
        { 'nacionalidad': 'CUBANA', 'pais': 'CUBA' },
        { 'nacionalidad': 'DAHONEYA', 'pais': 'DAHONEY' },
        { 'nacionalidad': 'DANES', 'pais': 'DINAMARCA' },
        { 'nacionalidad': 'DOMINICANA', 'pais': 'REP. DOMINICANA' },
        { 'nacionalidad': 'ECUATORIANA', 'pais': 'ECUADOR' },
        { 'nacionalidad': 'EGIPCIA', 'pais': 'EGIPTO' },
        { 'nacionalidad': 'EMIRATA', 'pais': 'EMIRATOS ARABES UDO.' },
        { 'nacionalidad': 'ESCOSESA', 'pais': 'ESCOCIA' },
        { 'nacionalidad': 'ESLOVACA', 'pais': 'REP. ESLOVACA' },
        { 'nacionalidad': 'ESPAÑOLA', 'pais': 'ESPAÑA' },
        { 'nacionalidad': 'ESTONA', 'pais': 'ESTONIA' },
        { 'nacionalidad': 'ETIOPE', 'pais': 'ETIOPIA' },
        { 'nacionalidad': 'FIJENA', 'pais': 'FIJI' },
        { 'nacionalidad': 'FILIPINA', 'pais': 'FILIPINAS' },
        { 'nacionalidad': 'FINLANDESA', 'pais': 'FINLANDIA' },
        { 'nacionalidad': 'FRANCESA', 'pais': 'FRANCIA' },
        { 'nacionalidad': 'GABIANA', 'pais': 'GAMBIA' },
        { 'nacionalidad': 'GABONA', 'pais': 'GABON' },
        { 'nacionalidad': 'GALESA', 'pais': 'GALES' },
        { 'nacionalidad': 'GHANESA', 'pais': 'GHANA' },
        { 'nacionalidad': 'GRANADEÑA', 'pais': 'GRANADA' },
        { 'nacionalidad': 'GRIEGA', 'pais': 'GRECIA' },
        { 'nacionalidad': 'GUATEMALTECA', 'pais': 'GUATEMALA' },
        { 'nacionalidad': 'GUINESA ECUATORIANA', 'pais': 'GUINEA ECUATORIAL' },
        { 'nacionalidad': 'GUINESA', 'pais': 'GUINEA' },
        { 'nacionalidad': 'GUYANESA', 'pais': 'GUYANA' },
        { 'nacionalidad': 'HAITIANA', 'pais': 'HAITI' },
        { 'nacionalidad': 'HOLANDESA', 'pais': 'HOLANDA' },
        { 'nacionalidad': 'HONDUREÑA', 'pais': 'HONDURAS' },
        { 'nacionalidad': 'HUNGARA', 'pais': 'HUNGRIA' },
        { 'nacionalidad': 'INDIA', 'pais': 'INDIA' },
        { 'nacionalidad': 'INDONESA', 'pais': 'INDONESIA' },
        { 'nacionalidad': 'INGLESA', 'pais': 'INGLATERRA' },
        { 'nacionalidad': 'IRAKI', 'pais': 'IRAK' },
        { 'nacionalidad': 'IRANI', 'pais': 'IRAN' },
        { 'nacionalidad': 'IRLANDESA', 'pais': 'IRLANDA' },
        { 'nacionalidad': 'ISLANDESA', 'pais': 'ISLANDIA' },
        { 'nacionalidad': 'ISRAELI', 'pais': 'ISRAEL' },
        { 'nacionalidad': 'ITALIANA', 'pais': 'ITALIA' },
        { 'nacionalidad': 'JAMAIQUINA', 'pais': 'JAMAICA' },
        { 'nacionalidad': 'JAPONESA', 'pais': 'JAPON' },
        { 'nacionalidad': 'JORDANA', 'pais': 'JORDANIA' },
        { 'nacionalidad': 'KATENSA', 'pais': 'KATAR' },
        { 'nacionalidad': 'KENIANA', 'pais': 'KENIA' },
        { 'nacionalidad': 'KUWAITI', 'pais': 'KWAIT' },
        { 'nacionalidad': 'LAOSIANA', 'pais': 'LAOS' },
        { 'nacionalidad': 'LEONESA', 'pais': 'SIERRA LEONA' },
        { 'nacionalidad': 'LESOTHENSA', 'pais': 'LESOTHO' },
        { 'nacionalidad': 'LETONESA', 'pais': 'LETONIA' },
        { 'nacionalidad': 'LIBANESA', 'pais': 'LIBANO' },
        { 'nacionalidad': 'LIBERIANA', 'pais': 'LIBERIA' },
        { 'nacionalidad': 'LIBEÑA', 'pais': 'LIBIA' },
        { 'nacionalidad': 'LIECHTENSTEIN', 'pais': 'LIECHTENSTEIN' },
        { 'nacionalidad': 'LITUANA', 'pais': 'LITUANIA' },
        { 'nacionalidad': 'LUXEMBURGO', 'pais': 'LUXEMBURGO' },
        { 'nacionalidad': 'MADAGASCAR', 'pais': 'MADAGASCAR' },
        { 'nacionalidad': 'MALACA', 'pais': 'FEDE. DE MALASIA' },
        { 'nacionalidad': 'MALAWI', 'pais': 'MALAWI' },
        { 'nacionalidad': 'MALDIVAS', 'pais': 'MALDIVAS' },
        { 'nacionalidad': 'MALI', 'pais': 'MALI' },
        { 'nacionalidad': 'MALTESA', 'pais': 'MALTA' },
        { 'nacionalidad': 'MARFILESA', 'pais': 'COSTA DE MARFIL' },
        { 'nacionalidad': 'MARROQUI', 'pais': 'MARRUECOS' },
        { 'nacionalidad': 'MAURICIO', 'pais': 'MAURICIO' },
        { 'nacionalidad': 'MAURITANA', 'pais': 'MAURITANIA' },
        { 'nacionalidad': 'MEXICANA', 'pais': 'MÉXICO' },
        { 'nacionalidad': 'MONACO', 'pais': 'MONACO' },
        { 'nacionalidad': 'MONGOLESA', 'pais': 'MONGOLIA' },
        { 'nacionalidad': 'NAURU', 'pais': 'NAURU' },
        { 'nacionalidad': 'NEOZELANDESA', 'pais': 'NUEVA ZELANDIA' },
        { 'nacionalidad': 'NEPALESA', 'pais': 'NEPAL' },
        { 'nacionalidad': 'NICARAGUENSE', 'pais': 'NICARAGUA' },
        { 'nacionalidad': 'NIGERANA', 'pais': 'NIGER' },
        { 'nacionalidad': 'NIGERIANA', 'pais': 'NIGERIA' },
        { 'nacionalidad': 'NORCOREANA', 'pais': 'COREA DEL NORTE' },
        { 'nacionalidad': 'NORIRLANDESA', 'pais': 'IRLANDA DEL NORTE' },
        { 'nacionalidad': 'NORTEAMERICANA', 'pais': 'ESTADOS UNIDOS' },
        { 'nacionalidad': 'NORUEGA', 'pais': 'NORUEGA' },
        { 'nacionalidad': 'OMANA', 'pais': 'OMAN' },
        { 'nacionalidad': 'PAKISTANI', 'pais': 'PAKISTAN' },
        { 'nacionalidad': 'PANAMEÑA', 'pais': 'PANAMA' },
        { 'nacionalidad': 'PARAGUAYA', 'pais': 'PARAGUAY' },
        { 'nacionalidad': 'PERUANA', 'pais': 'PERU' },
        { 'nacionalidad': 'POLACA', 'pais': 'POLONIA' },
        { 'nacionalidad': 'PORTORIQUEÑA', 'pais': 'PUERTO RICO' },
        { 'nacionalidad': 'PORTUGUESA', 'pais': 'PORTUGAL' },
        { 'nacionalidad': 'RHODESIANA', 'pais': 'RHODESIA' },
        { 'nacionalidad': 'RUANDA', 'pais': 'RUANDA' },
        { 'nacionalidad': 'RUMANA', 'pais': 'RUMANIA' },
        { 'nacionalidad': 'RUSA', 'pais': 'RUSSIA' },
        { 'nacionalidad': 'SALVADOREÑA', 'pais': 'EL SALVADOR' },
        { 'nacionalidad': 'SAMOA OCCIDENTAL', 'pais': 'SAMOA OCCIDENTAL' },
        { 'nacionalidad': 'SAN MARINO', 'pais': 'SAN MARINO' },
        { 'nacionalidad': 'SAUDI', 'pais': 'ARABIA SAUDITA' },
        { 'nacionalidad': 'SENEGALESA', 'pais': 'SENEGAL' },
        { 'nacionalidad': 'SIKKIM', 'pais': 'SIKKIM' },
        { 'nacionalidad': 'SINGAPUR', 'pais': 'SINGAPUR' },
        { 'nacionalidad': 'SIRIA', 'pais': 'SIRIA' },
        { 'nacionalidad': 'SOMALIA', 'pais': 'SOMALIA' },
        { 'nacionalidad': 'SOVIETICA', 'pais': 'UNION SOVIETICA' },
        { 'nacionalidad': 'SRI LANKA', 'pais': 'SRI LANKA (CEYLAN) ' },
        { 'nacionalidad': 'SUAZILANDESA', 'pais': 'SUAZILANDIA' },
        { 'nacionalidad': 'SUDAFRICANA', 'pais': 'SUDAFRICA' },
        { 'nacionalidad': 'SUDANESA', 'pais': 'SUDAN' },
        { 'nacionalidad': 'SUECA', 'pais': 'SUECIA' },
        { 'nacionalidad': 'SUIZA', 'pais': 'SUIZA' },
        { 'nacionalidad': 'SURCOREANA', 'pais': 'COREA DEL SUR' },
        { 'nacionalidad': 'TAILANDESA', 'pais': 'TAILANDIA' },
        { 'nacionalidad': 'TANZANA', 'pais': 'TANZANIA' },
        { 'nacionalidad': 'TONGA', 'pais': 'TONGA' },
        { 'nacionalidad': 'TONGO', 'pais': 'TONGO' },
        { 'nacionalidad': 'TRINIDAD Y TOBAGO', 'pais': 'TRINIDAD Y TOBAGO' },
        { 'nacionalidad': 'TUNECINA', 'pais': 'TUNEZ' },
        { 'nacionalidad': 'TURCA', 'pais': 'TURQUIA' },
        { 'nacionalidad': 'UGANDESA', 'pais': 'UGANDA' },
        { 'nacionalidad': 'URUGUAYA', 'pais': 'URUGUAY' },
        { 'nacionalidad': 'VATICANO', 'pais': 'VATICANO' },
        { 'nacionalidad': 'VENEZOLANA', 'pais': 'VENEZUELA' },
        { 'nacionalidad': 'VIETNAMITA', 'pais': 'VIETNAM' },
        { 'nacionalidad': 'YEMEN REP ARABE', 'pais': 'YEMEN REP. ARABE' },
        { 'nacionalidad': 'YEMEN REP DEM', 'pais': 'YEMEN REP. DEM' },
        { 'nacionalidad': 'YUGOSLAVA', 'pais': 'YUGOSLAVIA' },
        { 'nacionalidad': 'ZAIRE', 'pais': 'ZAIRE' }
      ];
    }
  }
};



// WEBPACK FOOTER //
// ./src/common/mixins/paises.js